module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BXUFo5/cover.jpeg?1685327174959",
      "alt": "This image is the cover for the book The Demon Sealing Story in Tibet, Volume 3"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Demon Sealing Story in Tibet, Volume 3\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In 1904, the defenses of Jiangzi were defeated by the unequipped Tibetan troops. The castle of Jiangzi was captured, the invaders were attacked by mysterious people during the looting of the Temple of the Zhongba River. The English army suffered heavy casualties, and the necromancers in the army were also severely injured. The invaders fled in a flurry, and the necromancers returned to find out the secret of Princess Wen Cheng's construction of the Twelve Towns of the Devil Temple after she entered the stronghold's stronghold.For the sake of this secret, many forces, including secret experts, Han Dynasty Warlocks, Conquerors, Northwest bandits, royalty, necromancers, Lhasa, Serpentine Tailed Land Gods, Demoness Appearance, War God's descendants, had launched fierce battles...")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nan ShanJiuZang, Babel Novel\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Funstory\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0